<template>
  <div :style="`width:${dispW}px;height:${dispH}px;position:relative;border-left: 1px solid gray`">
    <div style="padding-top: 10px; height: 240px">
      <div style="text-align: center; margin-bottom: 10px">
        <el-button style="border: 1px solid gray" @click="showRecomOK = true">{{
          $t("langcfg.txtOKRecomd")
        }}</el-button>
        <el-button style="border: 1px solid gray" @click="showRecomContactLens = true">{{
          $t("langcfg.txtContactLensRecomd")
        }}</el-button>
      </div>
      <el-form label-position="left" label-width="200px" :inline="true">
        <el-form-item
          :label="$t('langcfg.txtManufacturer') + ':'"
          style="line-height: 45px; font-size: 50px"
        >
          <el-select v-model="selMfrId" @change="selMfrChanged" placeholder="">
            <el-option
              v-for="(item, index) in manufactures"
              :key="index"
              :label="item.mfname"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-button @click="add('mfr')" :icon="manufacturerIcon['plus']"></el-button>
          <el-button
            @click="del('mfr')"
            :disabled="isDefaultMfr ? true : false"
            :icon="manufacturerIcon['minus']"
          ></el-button>
          <el-button
            @click="edit('mfr')"
            :disabled="isDefaultMfr ? true : false"
            icon="el-icon-edit"
          ></el-button>
        </el-form-item>
        <el-form-item
          :label="$t('langcfg.txtLen') + ':'"
          style="line-height: 45px; font-size: 50px"
        >
          <el-select v-model="selLenId" @change="selLenIdChanged" placeholder="">
            <el-option
              v-for="(item, index) in lens"
              :key="index"
              :label="item.lenname"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-button
            @click="add('len')"
            :disabled="isDefaultMfr ? true : false"
            :icon="manufacturerIcon['plus']"
          ></el-button>
          <el-button
            @click="del('len')"
            :disabled="isDefaultMfr ? true : false"
            :icon="manufacturerIcon['minus']"
          ></el-button>
          <el-button
            @click="edit('len')"
            :disabled="isDefaultMfr ? true : false"
            icon="el-icon-edit"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="div-table">
      <div :style="`height:${(dispH - 320) / 2}px;`">
        <el-table
          ref="mfsTable"
          :header-cell-style="headerRowStyle"
          :cell-style="cellStyle"
          :data="manufactures"
          style="width: 100%"
          :row-style="manufRowStyle"
          :highlight-current-row="false"
          row-key="keyid"
          :max-height="`${(dispH - 320) / 2}`"
          @current-change="currentManufChanged"
          :empty-text="emptyText"
        >
          <el-table-column prop="mfname" :label="$t('langcfg.txtManufacturer')" width="250">
          </el-table-column>
          <el-table-column
            prop="phone"
            :label="$t('langcfg.txtPhone')"
            width="200"
          ></el-table-column>
          <el-table-column prop="address" :label="$t('langcfg.txtAddress')"></el-table-column>
        </el-table>
      </div>
      <div :style="`margin-top:5px;height:${(dispH - 240) / 2}px;width:100%;`">
        <el-table
          id="table"
          ref="lensTable"
          :header-cell-style="headerRowStyle"
          :cell-style="cellStyle"
          :data="lens"
          :row-style="lenRowStyle"
          highlight-current-row
          row-key="keyid"
          :max-height="`${(dispH - 260) / 2}`"
          @current-change="currentLenChanged"
          :empty-text="emptyText"
        >
          <el-table-column
            prop="lenname"
            :label="$t('langcfg.txtLen')"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="r"
            label="R (mm)"
            width="320"
            :formatter="formatLenVal"
          ></el-table-column>
          <el-table-column
            prop="width"
            label="W (mm)"
            width="320"
            :formatter="formatLenVal"
          ></el-table-column>
          <el-table-column
            prop="ecc"
            label="ecc"
            width="320"
            :formatter="formatLenVal"
          ></el-table-column>
          <el-table-column
            prop="ecc"
            label="K"
            width="320"
            :formatter="formatLenKVal"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <RGPMfrEdit
      v-if="editMfr"
      :show.sync="editMfr"
      @save="save"
      @cancel="cancel"
      :mfrInfo="info"
    ></RGPMfrEdit>
    <RGPLenEdit
      v-if="editLen"
      :show.sync="editLen"
      @save="save"
      @cancel="cancel"
      :lenInfo="info"
    ></RGPLenEdit>
    <el-dialog
      v-if="showRecomOK"
      :title="$t('langcfg.txtCalRgpOK')"
      :visible.sync="showRecomOK"
      :width="language === 'zh_CN' || language === 'ja' ? '1200px' : '1400px'"
      append-to-body
      destroy-on-close
    >
      <RGPRecomOK :mapValues="mapValues" :record="record" :currentEye="currentEye" />
    </el-dialog>
    <el-dialog
      v-if="showRecomContactLens"
      :title="$t('langcfg.txtCalRgpContactLens')"
      :visible.sync="showRecomContactLens"
      :width="isDE ? '1820px' : '1800px'"
      append-to-body
      top="2vh"
      destroy-on-close
    >
      <RGPRecomContactLens :mapValues="mapValues" :record="record" :currentEye="currentEye" />
    </el-dialog>
  </div>
</template>
<script>
import { isDefined, INVALID_1000 } from "../shared/index";
import { Message } from "../..//mixins";

import { addMfr, delMfr, getMfrs, updateMfr } from "../js/RGP-Mfr";
import { addLen, delLen, delAllLens, getLensAll, updateLen } from "../js/Rgp-Len";
import RGPMfrEdit from "./RGP-MfrEdit";
import RGPLenEdit from "./RGP-LenEdit";
import RGPRecomOK from "./RGP-RecomOK";
import RGPRecomContactLens from "./RGP-RecomContactLens";
import { RGPMFRDEFAULTNAME, RGPMFRDEFAULTPHONE, RGPMFRDEFAULTADDRESS } from "../../shared/consts";
const rowstyle = {
  color: "white",
  fontSize: "20px",
  textAlign: "center",
  border: "1px solid rgba(255,255,255,0.1)"
};
const headstyle = {
  backgroundColor: "#2D3039",
  color: "white",
  fontSize: "20px",
  textAlign: "center",
  border: "1px solid rgba(255,255,255,0.1)",
  marginBottom: "10px"
};
const defaultLensMin = 6.9;
const defaultLensMax = 8.9;
const defaultLensInterval = 0.1;

export default {
  name: "RGPManufacturer",
  components: {
    RGPMfrEdit,
    RGPLenEdit,
    RGPRecomOK,
    RGPRecomContactLens
  },
  mixins: [Message],
  data() {
    return {
      lens: [],
      manufactures: [],
      currentManuf: {},
      currentLen: {},
      editMfr: false,
      editLen: false,
      isAdd: false,
      info: {},
      selMfrId: "",
      selLenId: "",
      cellStyle: {
        textAlign: "center",
        verticalAlign: "middle",
        border: "1px solid rgba(255,255,255,0.1)",
        color: "#bec0cc",
        paddingLeft: "5px",
        paddingRight: "5px"
      },
      showRecomOK: false,
      showRecomContactLens: false,
      emptyText: " ",
      isDE: false,
      language: window.settings.language
    };
  },
  created() {
    setTimeout(async () => {
      await this.initDefault();
      this.initdb();
    }, 100);
  },
  updated() {
    this.isDE = window.settings.language === "de";
    this.language = window.settings.language;
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width
    },
    dispH: {
      type: Number,
      default: window.screen.height - 122
    },
    RgpHelper: {
      required: true,
      type: Object
    },
    mapValues: {
      type: Object,
      default() {
        return {};
      }
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentEye: {
      type: String,
      default: ""
    }
  },
  methods: {
    initdb(clearSelMfr = true) {
      this.manufactures = [];
      this.lens = [];
      if (clearSelMfr) {
        this.currentManuf = {};
        this.currentLen = {};
        this.selMfrId = "";
        this.selLenId = "";
      }
      getMfrs()
        .then((mfrs) => {
          this.manufactures = mfrs;
          if (this.manufactures.length > 0) {
            this.currentManuf = {};
            if (this.selMfrId) {
              mfrs.forEach((item) => {
                if (item._id === this.selMfrId) {
                  this.currentManuf = item;
                }
              });
            }
            if (!this.currentManuf._id) {
              for (let i = 0; i < this.manufactures.length; i++) {
                if (this.manufactures[i].mfname === RGPMFRDEFAULTNAME) {
                  this.currentManuf = this.manufactures[i];
                  this.selMfrId = this.currentManuf._id;
                  break;
                }
              }
              if (!this.currentManuf._id) {
                this.currentManuf = this.manufactures[0];
                this.selMfrId = this.currentManuf._id;
              }
            }
            this.initLens();
          }
        })
        .catch((err) => {
          console.error(err);
          this.manufactures = [];
          this.lens = [];
        });
    },
    initLens() {
      this.lens = [];
      this.currentLen = {};
      this.selLenId = "";
      if (!isDefined(this.currentManuf) || !isDefined(this.currentManuf._id)) {
        return;
      }
      getLensAll(this.currentManuf._id)
        .then((lens) => {
          // console.log(lens)
          this.lens = lens;
          if (this.lens.length > 0) {
            this.currentLen = {};
            if (this.selLenId) {
              lens.forEach((item) => {
                if (item._id === this.selLenId) {
                  this.currentLen = item;
                }
              });
            }
            if (!this.currentLen._id) {
              if (this.isDefaultMfr) {
                this.autoSelectLens();
              } else {
                this.currentLen = this.lens[0];
                this.selLenId = this.currentLen._id;
              }
            }
          }
        })
        .catch((err) => {
          console.error(err);
          this.lens = [];
        });
    },
    autoSelectLens() {
      const RECOMMEND_LENS_MIN = 6.9;
      const RECOMMEND_LENS_MAX = 8.9;
      const RECOMMEND_LENS_INTERVAL = 0.1;
      let rm = this.mapValues.params.Rm.value;
      if (rm === INVALID_1000) {
        return;
      }
      rm = Math.round(rm * 10) / 10;
      if (rm < RECOMMEND_LENS_MIN) rm = RECOMMEND_LENS_MIN;
      else if (rm >= RECOMMEND_LENS_MAX) rm = RECOMMEND_LENS_MAX - RECOMMEND_LENS_INTERVAL;
      let r2 = (rm + 0.1)._toFixed(2);
      for (let i = 0; i < this.lens.length; i++) {
        if (this.lens[i].r[2] === r2) {
          this.currentLen = this.lens[i];
          this.selLenId = this.currentLen._id;
          break;
        }
      }
    },
    async initDefault(cb) {
      let allMfrs = await getMfrs();
      if (isDefined(allMfrs) && allMfrs.length > 0) {
        let hadDefault = allMfrs.some((val) => {
          return val.mfname === RGPMFRDEFAULTNAME;
        });

        if (hadDefault) return true;
      }

      try {
        let addMfrRes = await addMfr(RGPMFRDEFAULTNAME, RGPMFRDEFAULTPHONE, RGPMFRDEFAULTADDRESS);
        let mfrid = addMfrRes._id;
        let count = 0;
        for (
          let start = defaultLensMin;
          start < defaultLensMax;
          start = parseFloat((start + defaultLensInterval)._toFixed(1)), count++
        ) {
          let lensInfo = this.getDefaultLensInfo(start);
          let addLenRes = await addLen(
            mfrid,
            `M${String(count + 1).padStart(2, "0")}`,
            lensInfo.r,
            lensInfo.ecc,
            lensInfo.w,
            lensInfo.toricR
          );
        }
        return true;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    getDefaultLensInfo(start) {
      let r = [
        (start + 0.4)._toFixed(2),
        (start - 0.4)._toFixed(2),
        (start + 0.1)._toFixed(2),
        (start + 0.4)._toFixed(2),
        0,
        0,
        0
      ];
      let w = [3, 0.5, 0.5, 1, 0, 0, 0];
      let ecc = new Array(7);
      ecc.fill(0);
      let toricR = new Array(7);
      toricR.fill(0);
      return { r, w, ecc, toricR };
    },
    getEmptyLensInfo() {
      let obj = { r: [], width: [], ecc: [], toric_r: [] };
      for (let i = 0; i < 7; i++) {
        obj.r.push(0);
        obj.width.push(0);
        obj.ecc.push(0);
        obj.toric_r.push(0);
      }
      return obj;
    },
    add(mode) {
      this.isAdd = true;
      if (mode === "mfr") {
        this.info = {};
        this.editMfr = true;
      } else if (mode === "len") {
        this.info = this.getEmptyLensInfo();
        this.editLen = true;
      }
    },
    del(mode) {
      let isMfr = mode === "mfr";
      let msgConfirm = isMfr
        ? this.$t("langcfg.txtConfirmToDelMfr")
        : this.$t("langcfg.txtConfirmToDelLen");
      let msgSuccess = isMfr
        ? this.$t("langcfg.txtSuccessToDelMfr")
        : this.$t("langcfg.txtSuccessToDelLen");
      let msgFail = isMfr ? this.$t("langcfg.txtFailToDelMfr") : this.$t("langcfg.txtFailToDelLen");
      let canDel = isMfr
        ? isDefined(this.currentManuf) && isDefined(this.currentManuf._id)
        : isDefined(this.currentLen) && isDefined(this.currentLen._id);
      if (!canDel) return;
      this.confirm(msgConfirm, this.$t("langcfg.txtOK"), this.$t("langcfg.txtCancel"))
        .then(() => {
          if (isMfr) {
            // 需要先删除对应的镜片信息
            delAllLens(this.currentManuf._id)
              .then(() => {
                delMfr(this.currentManuf._id).then(() => {
                  this.notify(msgSuccess, "", "success");
                  this.initdb();
                });
              })
              .catch((err) => {
                console.error("del mfr:", err);
                this.notify(msgFail, "", "error");
              });
          } else {
            delLen(this.currentLen._id)
              .then(() => {
                this.notify(msgSuccess, "", "success");
                this.initLens();
              })
              .catch((err) => {
                console.error("del len:", err);
                this.notify(msgFail, "", "error");
              });
          }
        })
        .catch(() => {});
    },
    edit(mode) {
      this.isAdd = false;
      if (mode === "mfr") {
        if (!isDefined(this.currentManuf) || !isDefined(this.currentManuf._id)) {
          return;
        }
        this.info = this.currentManuf;
        this.editMfr = true;
      } else if (mode === "len") {
        if (!isDefined(this.currentLen) || !isDefined(this.currentLen._id)) {
          return;
        }
        this.info = this.currentLen;
        this.editLen = true;
      }
    },
    save(info) {
      if (this.editMfr) {
        if (this.isAdd) {
          addMfr(info.mfname, info.phone, info.address).then((res) => {
            this.selMfrId = res._id;

            this.initdb(false);
          });
        } else {
          updateMfr(info._id, info.mfname, info.phone, info.address).then((res) => {
            this.initdb(false);
          });
        }
      } else if (this.editLen) {
        if (this.isAdd) {
          addLen(
            this.currentManuf._id,
            info.lenname,
            info.r,
            info.ecc,
            info.width,
            info.toric_r
          ).then(() => {
            this.selLenId = this.currentManuf._id;
            this.initLens();
          });
        } else {
          updateLen(
            info._id,
            info.mfrid,
            info.lenname,
            info.r,
            info.ecc,
            info.width,
            info.toric_r
          ).then(() => {
            this.initLens();
          });
        }
      }

      this.editMfr = this.editLen = false;
    },
    cancel() {
      this.isAdd = false;
      this.editMfr = this.editLen = false;
    },
    selMfrChanged(value) {
      this.currentManuf = {};
      this.manufactures.forEach((item) => {
        if (item._id === value) {
          this.currentManuf = item;
        }
      });
      this.initLens();
    },
    selLenIdChanged(value) {
      this.currentLen = {};
      if (this.lens) {
        this.lens.forEach((item) => {
          if (item._id === value) {
            this.currentLen = item;
          }
        });
      }
    },
    headerRowStyle() {
      return headstyle;
    },
    lenRowStyle({ row, rowIndex }) {
      if (this.currentLen._id === row._id) {
        this.$nextTick(() => {
          this.$refs.lensTable.bodyWrapper.scrollTop = rowIndex * 64;
        });
        return { background: "rgba(0,0,0,0.3)", ...rowstyle };
      } else {
        return { background: "#2D3039", ...rowstyle };
      }
    },
    manufRowStyle({ row, rowIndex }) {
      if (this.currentManuf._id === row._id) {
        this.$nextTick(() => {
          this.$refs.mfsTable.bodyWrapper.scrollTop = rowIndex * 64;
        });
        return { background: "rgba(0,0,0,0.3)", ...rowstyle };
      } else {
        return { background: "#2D3039", ...rowstyle };
      }
    },
    currentLenChanged(row) {
      this.currentLen = row;
      this.selLenId = this.currentLen._id;
    },
    currentManufChanged(row) {
      this.currentManuf = row;
      this.selMfrId = row._id;
      this.initLens();
    },
    formatLenVal(row, column) {
      let obj = row[column.property];
      if (Array.isArray(obj)) {
        return obj.join(", ");
      } else {
        return obj;
      }
    },
    formatLenKVal(row, column) {
      let obj = row[column.property];
      if (Array.isArray(obj)) {
        let tmp = [];
        obj.forEach((item) => {
          let k = -Math.pow(item, 2);
          tmp.push(isNaN(k) ? 0 : Math.round(k * 100) / 100);
        });
        return tmp.join(", ");
      } else {
        return obj;
      }
    }
  },
  watch: {
    currentLen() {
      this.$emit("lensChange", this.currentLen);
    }
  },
  computed: {
    manufacturerIcon() {
      return {
        plus: "el-icon-plus",
        minus: "el-icon-minus"
      };
    },
    isDefaultMfr() {
      if (isDefined(this.currentManuf)) {
        return this.currentManuf.mfname === RGPMFRDEFAULTNAME;
      }
      return false;
    }
  }
};
</script>
<style scoped>
.map-title {
  font-size: 30px;
  width: 500px;
  height: 50px;
  background-color: #44444c;
  color: white;
}
input {
  font-size: 30px;
  width: 460px;
  height: 46px;
  background-color: #fff;
  color: black;
  margin: 0px;
  border: none;
}
.el-form-item /deep/ .el-form-item__label {
  line-height: 50px;
  font-size: 25px;
}
.el-form-item {
  margin-top: 10px;
}

.el-button {
  background: transparent;
  color: white;
  font-size: 25px;
}
.el-button > i {
  font-size: 25px;
}
.option {
  font-size: 28px;
  padding-top: 30px;
  margin-top: 30px;
}
.el-table::before {
  height: 0px;
}
.div-table {
  margin-right: 10px;
  cursor: pointer;
  position: relative;
}

.el-table /deep/ .cell {
  /* overflow: hidden;
  text-overflow: ellipsis; */
  text-align: center;
  word-break: keep-all;
}
.el-table--scrollable-x /deep/ .el-table__body-wrapper {
  color: red;
  /* overflow-x: hidden; */
}
.el-row {
  margin-top: 30px;
  font-size: 30px;
}
.el-input-number /deep/ .el-input__inner {
  font-size: 30px;
}
.el-select /deep/ input {
  font-size: 30px;
  width: 460px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}
.el-select >>> .el-input__inner {
  font-size: 30px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}
li.el-select-dropdown__item {
  font-size: 40px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}
.el-select-dropdown__item /deep/ span {
  font-size: 25px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}
</style>

<style lang="less">
#table {
  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 0px;
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 1);
    background-color: rgba(0, 0, 0, 0.4);
  }

  ::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 1);
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-Manufacturer.vue